// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI  from 'element-ui'
import fetch from './utils/fetch'
import store from './store/index'
import echarts from 'echarts'



Vue.prototype.$echarts = echarts

// import 'lib-flexible/flexible'

import 'element-ui/lib/theme-chalk/index.css'
import "../src/assets/style/reset.css"
import 'video.js/dist/video-js.css'

import './element-variables.scss'
import "../src/assets/style/media.css"

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css' // 引入样式
import 'vue-video-player/src/custom-theme.css' // 引入样式
import 'videojs-flash'
Vue.use(VueVideoPlayer)

Vue.prototype.$http = fetch
Vue.config.productionTip = false
// 创建全局bus对象 用于兄弟组件传值
Vue.prototype.bus = new Vue()

Vue.use(ElementUI)
router.beforeEach((to, from, next) => {
  if(!sessionStorage.getItem('user')){
    const userInfo = {"id":"b714260b4b0a3e09733142c2e94bc11b","name":"超级管理员","account":"admin","password":"123456","moduleIdList":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],"moduleList":[{"id":1,"name":"首页"},{"id":2,"name":"能人库"},{"id":3,"name":"人才库"},{"id":15,"name":"专家库"},{"id":4,"name":"项目库"},{"id":17,"name":"未能返乡能人库"},{"id":5,"name":"资源库"},{"id":6,"name":"政策信息"},{"id":7,"name":"乡村园区"},{"id":8,"name":"新农协"},{"id":9,"name":"数据统计"},{"id":10,"name":"首页-监控"},{"id":11,"name":"能人库-详情"},{"id":12,"name":"人才库-详情"},{"id":13,"name":"项目库-详情"},{"id":14,"name":"乡村园区-监控"},{"id":16,"name":"专家库-详情"},{"id":18,"name":"未能返乡能人库-详情"}]};
    sessionStorage.setItem('user',JSON.stringify(userInfo));
    next();
  }else{
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js